import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogContent,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import {MatListModule} from '@angular/material/list';
import {MatIconModule} from '@angular/material/icon';
import {MatCheckboxModule} from '@angular/material/checkbox';

import { SelectOption, SelectOptionValue } from '../select';

type SelectOptionDialog  = SelectOption & { selected: boolean };

export interface OptionsDialogData {
  options: SelectOption[];
  selected: SelectOptionValue[];
  multiple: boolean;
}

@Component({
  selector: 'app-options-dialog',
  standalone: true,
  imports: [
    MatButtonModule,
    MatDialogModule,
    MatListModule,
    MatIconModule,
    MatCheckboxModule,
  ],
  templateUrl: './options-dialog.component.html',
  styleUrl: './options-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OptionsDialogComponent {
  options: SelectOptionDialog[];
  multiple: boolean;
  
  private readonly dialogData = inject<OptionsDialogData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<OptionsDialogComponent>);

  constructor() {
    this.options = this.dialogData.options.map((option) => ({
      ...option,
      selected: this.dialogData.selected.includes(option.value)
    }));
    this.multiple = this.dialogData.multiple;

    this.dialogRef.backdropClick().subscribe(() => {
      this.closeDialog();
    });
  }

  selectOption(option: SelectOptionDialog) {
    if (this.multiple) {
      option.selected = !option.selected;
    } else {
      this.dialogRef.close([option.value]);
    }
  }

  closeDialog() {
    this.dialogRef.close(this.options.filter(option => option.selected).map(option => option.value));
  }
}
